module.exports = {
  endpoint: "https://juren-event-liff.rydn.dev/eventapi/api",
  liffId: "1653848204-7vNY18kV"
};



// WEBPACK FOOTER //
// ./src/config.js